import { render, staticRenderFns } from "./Product-public.vue?vue&type=template&id=6e9b07e5&scoped=true&lang=pug"
import script from "./Product-public.vue?vue&type=script&lang=js"
export * from "./Product-public.vue?vue&type=script&lang=js"
import style0 from "./Product-public.vue?vue&type=style&index=0&id=6e9b07e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b07e5",
  null
  
)

export default component.exports